import React from "react";
import { Box } from "@mui/material";
import {
  birthCardDef,
  codeCardDef,
  nameCardDef,
} from "my-hr/configs/my-hr-info-card-defs";
import { OcInfoCard, OcInfoCardItem, OcCard, OcPageTransition } from "oc/components";
import { useTranslation } from "react-i18next";

type BankAccount = { bankAccountNumber: string };
type Employee = { bankAccounts?: BankAccount[];[key: string]: unknown };

type MyHrPersonalDataPanelProps = {
  employee: Employee;
  onEdit: (type: string, modifier: unknown) => void;
  hasChangeRequest: boolean;
  editable?: boolean;
};

export const MyHrPersonalDataPanel = ({
  employee,
  onEdit,
  hasChangeRequest,
  editable = false,
}: MyHrPersonalDataPanelProps) => {
  const { t } = useTranslation();

  const hasBankAccount: BankAccount[] =
    employee?.bankAccounts?.length ? employee.bankAccounts! : [{ bankAccountNumber: "" }];

  return (
    <OcPageTransition>
      <>
        <Box id="tab-panel-container">
          <Box paddingBottom="16px">
            <OcInfoCard
              def={nameCardDef}
              data={employee}
              editable={editable}
              onEdit={onEdit}
              hasChangeRequest={hasChangeRequest}
            />
          </Box>
          <Box paddingBottom="16px">
            <OcInfoCard
              def={birthCardDef}
              data={employee}
              onEdit={onEdit}
              hasChangeRequest={hasChangeRequest}
              editable={editable}
            />
          </Box>
          <Box paddingBottom="16px">
            <OcInfoCard
              def={codeCardDef}
              data={employee}
              onEdit={onEdit}
              hasChangeRequest={hasChangeRequest}
              editable={editable}
            />
          </Box>
          <Box paddingBottom="16px">
            <OcCard label={t("MY_HR_BANK_ACCOUNTS")}>
              {hasBankAccount?.map((item, index) => (
                <OcInfoCardItem
                  key={`${item.bankAccountNumber}-${index}`}
                  label={`${t(`MY_HR_BANK_ACCOUNT`)} ${index + 1}`}
                  value={item?.bankAccountNumber}
                  type={item?.bankAccountNumber}
                  editable={false}
                />
              ))}
            </OcCard>
          </Box>
        </Box>
      </>
    </OcPageTransition>
  );
};

export default MyHrPersonalDataPanel;
